import {AppMenuItem} from '../../shared/interfaces/menu-config-interface';
import {TipoPuntoVentaEnum} from '../../shared/enums/tipo-punto-venta-enum';
import {AmbienteEnum} from '../../shared/enums/ambiente-enum';
import {SociedadEnum} from '../../shared/enums/sociedad-enum';
import {MENU_PERMISSIONS} from '../constants/menu-permissions.constant';

export const FOLIOS_MENU: AppMenuItem = {
  "label": "Folios",
  "visible": true,
  "children": [
    {
      "ambientes": [
        AmbienteEnum.Desarrollo,
        AmbienteEnum.Calidad,
        AmbienteEnum.Capacitacion,
        AmbienteEnum.Produccion
      ],
      "sociedades": [
        SociedadEnum.FP,
        SociedadEnum.PE
      ],
      "label": "Aumenta Consecutivo Folio",
      "route": "notaRemision/aumentar-consecutivo-nota",
      "proceso": MENU_PERMISSIONS.aumentaConsecutivoNota,
      "tipoPuntoVenta": [
        TipoPuntoVentaEnum.Corporativo,
        TipoPuntoVentaEnum.PuntoVentaPropio
      ],
      "visible": true
    }
  ]
};
